import * as types from '../actions/actionTypes';

export default function routerReducer(state: any = { previousLocation: '' }, action: any) {
    switch (action.type) {
        case types.SAVE_PREVIOUS_LOCATION:
            return {
                ...state,
                previousLocation: action.result
            };

        default:
            return state;
    }
}
